import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const getVerticalOffsetForOverlay = () => {
  //mobile height
  if (window.innerWidth < variables.desktop_breakpoint) {
    if (window.scrollY === 0) {
      return '110px';
    } else {
      return '60px';
    }
  }

  //desktop height
  else {
    if (window.scrollY === 0) {
      return '147px';
    } else {
      return '60px';
    }
  }
};
